module.exports = __webpack_public_path__ + "static/media/4_.5ccd7a79.png";